module.exports = __webpack_public_path__ + "static/media/search-white.00ddfb5f.png";